define('review',[
  "globals",
  "views/review"
], function (globals, ReviewView) {
  "use strict";

  $(function () {
    new ReviewView({
      el: $(".review"),
      model: globals.content
    });
  });
});

